import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUploadIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 16.592,
	viewBox: "0 0 14 16.592",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Group_4047",
		"data-name": "Group 4047",
		transform: "translate(-5 -3.408)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_6815",
			"data-name": "Path 6815",
			d: "M7.4,10H8.99v5a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V10h1.59a1,1,0,0,0,.71-1.71L12.7,3.7a1,1,0,0,0-1.41,0L6.7,8.29A1,1,0,0,0,7.4,10ZM5,19a1,1,0,0,0,1,1H18a1,1,0,0,0,0-2H6A1,1,0,0,0,5,19Z",
			fill: "#fff"
		})
	})
});
export { SvgUploadIcon as ReactComponent };
